'use client';

import React from 'react';
import { CheckCircle, X, AlertCircle, Info } from 'lucide-react';

interface CustomToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  subMessage?: string;
  onClose?: () => void;
}

const CustomToast: React.FC<CustomToastProps> = ({
  message,
  type = 'success',
  subMessage,
  onClose
}) => {
  // Icon based on toast type
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-6 h-6 text-green-500" />;
      case 'error':
        return <AlertCircle className="w-6 h-6 text-red-500" />;
      case 'info':
        return <Info className="w-6 h-6 text-blue-500" />;
      default:
        return <CheckCircle className="w-6 h-6 text-green-500" />;
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 max-w-md w-full md:w-auto animate-slide-in">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-start">
        <div className="flex-shrink-0">
          {getIcon()}
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm font-medium text-gray-900">{message}</p>
          {subMessage && (
            <p className="mt-1 text-sm text-gray-500">{subMessage}</p>
          )}
        </div>
        <button
          onClick={onClose}
          className="ml-4 flex-shrink-0 text-gray-400 hover:text-gray-500 focus:outline-none"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default CustomToast; 